import toolsClient from "@/api/toolsClient";

export const getAutomationSettings = async (stationKey) => {
  const response = await toolsClient.get(`stations/${stationKey}/libretime`);

  return response.data;
};

export const makeAutomationRequest = async (stationKey, request) => {
  const response = await toolsClient.post(
    `stations/${stationKey}/libretime/request`,
    {
      action: request ? "enable" : "disable",
    }
  );

  return response.data;
};
